const buildMatchupState = ({ gameCodeOverride, strikes, balls }) => {
    if (gameCodeOverride === 'P') {
        return 'VS.';
    }

    if (typeof balls !== 'undefined' && typeof strikes !== 'undefined') {
        return `${balls} - ${strikes}`;
    }

    return '';
};

export default buildMatchupState;
